"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  common: {
    query: '查询',
    export: '导出',
    exports: '批量导出',
    save: '保存',
    updates: '批量更新',
    saveAndAdd: '保存并新增',
    submit: '提交',
    cancel: '取消',
    goBack: '返回',
    operation: '操作',
    edit: '编辑',
    delete: '删除',
    detail: '详情',
    reset: '重置',
    add: '新增'
  },
  verification: {
    operationFailure: '操作失败',
    studyCircularLaws: '通告法规学习',
    assignedLearning: '指派学习',
    companyNotice: '公司通告',
    externalRegulations: '外部法规',
    today: '今天',
    week: '一周',
    mounth: '一月内',
    year: '一年内',
    applicationDate: '申领日期',
    verificationMsg1: '不能为空',
    verificationMsg2: '数据类型为数字',
    verificationMsg3: '未找到文件，请联系管理员'
  },
  circularCatalog: {
    index: {
      title: '通告与法规',
      item: '通告与法规分类',
      query: {
        itemName: '项目名称'
      },
      table: {
        className: '分类名称',
        remarks: '备注'
      },
      form: {
        parentId: '上一级分类',
        standardNameCn: '分类名称(Cn)',
        standardNameEn: '分类名称(En)',
        dispOrder: '显示顺序',
        remarks: '备注'
      }
    }
  },
  circularManager: {
    index: {
      circularCatalog: '分类维护',
      title: '通告与法规',
      item: '通告与法规维护',
      deteleMessage: '目录下包含未删除的子目录，请先删除子目录！',
      query: {
        itemName: '项目名称',
        vessel: '涉及船舶',
        dept: '编制部门',
        uploadDate: '上传日期',
        yes: '是',
        no: '否',
        examination: '是否涉及考试',
        async: '船岸同步',
        isValid: '是否有效',
        involveDept: '涉及部门',
        role: '涉及岗位',
        deptMonitor: '监控部门',
        roleMonitor: '监控岗位',
        circleWork: '周期性工作',
        syncFlag: '船岸同步'
      },
      table: {
        qualityFileNo: '文件编号',
        qualityFileName: '文件名称',
        qualityFileType: '文件类型',
        qualityFileStatus: '状态',
        qualityFileDate: '生效日期',
        learnDeadline: '学习完成日期',
        learnDetail: '学习情况',
        feedbackDeadline: '落实完成日期',
        actual: '落实情况',
        attachmentsInfoId: '相关附件',
        timeChoose: '时间选择',
        vessel: '涉及船舶',
        dept: '编制部门',
        qualityVersion: '版本号',
        async: '是否船岸同步',
        examination: '是否涉及考试',
        systemFile: '体系文件',
        circular: '公司通告',
        External: '外部资料法规',
        Supportive: '支持性文件',
        Practices: '最佳实践'
      },
      form: {
        applicableCompany: '适用公司',
        file: '文件',
        fileProperties: '文件属性',
        taskAllocation: '学习落实任务分配',
        yes: '是',
        no: '否',
        catalog: '分类',
        qualityFileTyep: '类型',
        qualityFileNo: '中文编号',
        qualityFileNoEn: '英文编号',
        qualityFileDate: '生效日期',
        qualityFileNameCn: '中文名称',
        qualityFileNameEn: '英文名称',
        qualityDueDate: '失效日期',
        resionRemark: '原因说明',
        sysOrgId: '涉及部门',
        vesselCode: '涉及船舶',
        syncFlag: '是否船岸同步',
        examFlag: '是否需要考试',
        learnFlag: '要求学习',
        learnDeadline: '学习完成日期',
        learnDept: '学习部门',
        learnShip: '学习船舶',
        learnRemark: '学习要求',
        feedbackRemark: '要求落实反馈',
        feedbackDeadline: '落实完成日期',
        implementDept: '落实部门',
        implementName: '落实监控人',
        implementShip: '落实船舶',
        implementRemarks: '落实要求',
        mainBody: '正文',
        upMainBody: '上传正文',
        attachmentsInfoId: '附件',
        uploadAttachment: '上传附件',
        responsibleDepartment: '责任部门',
        uploader: '上传人',
        uploadDate: '上传日期',
        sync: '同步',
        unSync: '不同步',
        exam: '需要',
        unExam: '不需要',
        effectiveFlag: '是否有效',
        effective: '有效',
        unEffective: '失效',
        overdueDate: '失效时间',
        selectOverdueDate: '请选择失效时间'
      }
    }
  }
};